const _ = require('lodash');

const Address = require('../entities/address');

const Location = require('../entities/location');

const PagedList = require('../entities/paged-list');

const searchFields = ['id', 'name', 'enabled', 'address(id,streetAddress,street,city,state,country,centre)'];

const parse = json => new Location({
  id: json.id,
  name: json.name,
  address: new Address(json.address)
});

class OfferLocationsRepo {
  constructor(client
  /*: ApiClient*/
  , parentContext
  /*: Object*/
  , offerId
  /*: string*/
  ) {
    this.client = client;
    this.context = parentContext;
    this.offerId = offerId;
  }

  list()
  /*: (Promise<PagedList<Location>>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context && this.context.serialize();
    const offerId = this.offerId;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/locations`;
    const req = new this.client.Request(path, {}, ['id']);
    req.parse = parse; // FIXME: When the API has a way to get Location models by Offer id, stop doing this insane thing...

    req.transform = locationIds => {
      const ids = locationIds.items.map(loc => loc.id);
      return Promise.all(ids.map(id => this.details(id))) // Compact locations in case search index doesn't have some locations
      .then(locations => new PagedList(_.compact(locations), locationIds.page));
    };

    return this.client.get(req);
  } // Request Location details from Offer Index


  search({
    /*: {
        query: string,
        enabled: boolean,
        attached: boolean
      }*/

    query,
    enabled,
    attached
  } = {})
  /*: Promise<PagedList<Location>>*/
  {
    const {
      propertyId,
      businessId
    } = this.context && this.context.serialize();
    const offerId = this.offerId;
    const path = `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/locations/search`;
    const req = new this.client.Request(path, {
      q: query,
      enabled,
      attached
    }, searchFields);
    req.parse = parse;
    return this.client.get(req);
  } // FIXME: Duplicate of details in LocationRepo
  // Because I don't have time to refactor things to avoid circular dependencies


  details(locationId
  /*: string*/
  )
  /*: Promise<Location>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = `/properties/${propertyId}/businesses/${businessId}/locations/search`;
    const req = new this.client.Request(path, {
      locationId
    }, searchFields);
    req.parse = parse;
    return this.client.get(req).then(list => list.items[0]);
  }

}

module.exports = OfferLocationsRepo;